export default {
  leaderBoardList: [],
  freadomPointLeaderBoardList: [],
  loader: false,
  search_leaderBoard: '',
};
